import { render, staticRenderFns } from "./BihamkReportDetails.vue?vue&type=template&id=45a2805e&scoped=true&"
import script from "./BihamkReportDetails.vue?vue&type=script&lang=js&"
export * from "./BihamkReportDetails.vue?vue&type=script&lang=js&"
import style0 from "./BihamkReportDetails.vue?vue&type=style&index=0&id=45a2805e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a2805e",
  null
  
)

export default component.exports